import {
    FETCH_REFERRED_DRIVERS_REQUEST,
    FETCH_REFERRED_DRIVERS_SUCCESS,
    FETCH_REFERRED_DRIVERS_FAILURE,
} from "./types";

import { fetchReferredDrivers } from "../../services/referredDriverService";

export const fetchReferredDriversRequest = () => ({
    type: FETCH_REFERRED_DRIVERS_REQUEST,
});

export const fetchReferredDriversSuccess = (
    payload
) => ({
    type: FETCH_REFERRED_DRIVERS_SUCCESS,
    payload,
});

export const fetchReferredDriversFailure = (
    error
) => ({
    type: FETCH_REFERRED_DRIVERS_FAILURE,
    payload: error,
});

export const fetchReferredDriversAction =
    (
        referralCode,
        page = 1,
        size = 10
    ) =>
    async (dispatch) => {
        dispatch(
            fetchReferredDriversRequest()
        );

        try {
            const response =
                await fetchReferredDrivers(
                    referralCode,
                    page,
                    size
                );

            if (response.success) {
                dispatch(
                    fetchReferredDriversSuccess(
                        response.data
                    )
                );

                return response;
            }

            dispatch(
                fetchReferredDriversFailure(
                    response.error
                )
            );

            return response;
        } catch (error) {
            dispatch(
                fetchReferredDriversFailure(
                    error.message
                )
            );

            return {
                success: false,
                error: error.message,
            };
        }
    };